import {get, post} from '../interceptor'

let preUrl = '/mc';
export default {
  /** 网关管理接口 **/
  refreshGateway(params) { return post(preUrl, 'Gateway/refreshGateway', params); },
  getGatewayInfo(params) { return post(preUrl, 'Gateway/getGatewayInfo', params); },
  updateGatewayInfo(params) { return post(preUrl, 'Gateway/updateGatewayInfo', params); },
  getBuildTree(params) { return post(preUrl, 'Gateway/getBuildTree', params); },
  getBuildList(params) { return post(preUrl, 'Gateway/getBuildList', params); },
  /** 感知器管理接口 **/
  getSensorInfo(params) { return post(preUrl, 'Sensor/getSensorInfo', params); },
  updateSensorInfo(params) { return post(preUrl, 'Sensor/updateSensorInfo', params); },
  getGatewayTree(params) { return post(preUrl, 'Sensor/getGatewayTree', params); },
  getSensorList(params) { return post(preUrl, 'Sensor/getSensorList', params); }
}



// WEBPACK FOOTER //
// ./src/api/energy/manageCenter.js